export enum ActionTypes {
  GEOCODE_LAT_LNG_BATCH_REQUEST = 'GEOCODE_LAT_LNG_BATCH_REQUEST',
  GEOCODE_LAT_LNG_BATCH_SUCCEEDED = 'GEOCODE_LAT_LNG_BATCH_SUCCEEDED',
  GEOCODE_LAT_LNG_BATCH_FAILED = 'GEOCODE_LAT_LNG_BATCH_FAILED',
}
